module.exports = __webpack_public_path__ + "static/photo-rob-78f72e37aa2f124166e644087ef79d32.png";